<template>
  <div class="bg-[var(--bg)]">
    <!-- menu -->
      <NavBar/>
      <Notifications />
      <!-- sidebar wrapper -->
    <div
      class="
        w-full
        z-40
      "
    >
      <NewEventModal />
      <EventDetailsModal />
          <ModalPlanner />
      <!-- sidebar -->
      <Sidebar v-if="showSidebar && !isHome" />
    </div>
    <!-- content -->
    <div
      data-scroll-container="app-content"
      class="overflow-y-auto transition-[padding] duration-300"
      :class="
        !isAuth || isHome
          ? 'pl-0'
          : store.state.sidebar
            ? 'sm:pl-64'
            : 'sm:pl-12'
      "
    >
      <main class="flex flex-col">
        <div class="min-h-screen">
          <router-view />
        </div>
      </main>
    <!-- footer -->
    <footer
      v-if="!showSidebar"
      class="bg-[var(--bg)] group">
      <div class="w-full h-px bg-line"></div>
      <div
        class="
          container mx-auto px-12 text-center

          sm:px-24
        "
      >
        <div
          class="
            flex flex-col
            justify-between
            w-full
            py-16 mb-8

            sm:flex-row sm:items-start
          "
          >
          <a
            :href="`${usersLink}`"
            target="_blank"
            class="mb-10 sm:mb-0
            "
          >
            <img
              :src="isLight
              ? '/img/logo-digi-light.svg'
              : '/img/logo-digi.svg'"
              alt="Logo"
              class="
              h-6 opacity-30
              group-hover:opacity-100
              courser-pointer"
            />
          </a>
          <div
            class="
              flex space-x-12
              mr-0
              opacity-30
              group-hover:opacity-100
              transition-all duration-500 ease-in-out

              sm:mr-20 sm:mx-0
              sm:space-x-20
            "
          >
          <div class="text-left">
            <h3 class="text-sm text-[var(--text)] font-regular mb-4">Products</h3>
            <ul
              class="
                space-y-2
                text-xs text-[var(--text)] font-light
                pl-1
              "
            >
              <li>
                <router-link
                  :to="isAuth ? '/app' : '/'"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Sky
                </router-link>
              </li>
              <li>
                <a
                  href="https://fireweb.digiapps.com.co/"
                  target="_blank"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Fireweb
                </a>
              </li>
              <li>
                <a
                  href="https://care.digiapps.com.co/"
                  target="_blank"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Care
                </a>
              </li>
              <li>
                <a
                  href="https://utils.digiapps.com.co/"
                  target="_blank"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Utils
                </a>
              </li>
            </ul>
          </div>
          <div class="text-left">
            <h3 class="text-sm text-[var(--text)] font-regular mb-4">Contact Us</h3>
            <ul
              class="
                space-y-2
                text-xs text-[var(--text)] font-light
                pl-1
              "
            >
              <li>
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@digiapps.com.co"
                  target="_blank"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Help Center
                </a>
              </li>
              <li>
                <a
                  href="https://discord.gg/n8NHa6sJbc"
                  target="_blank"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Discord
                </a>
              </li>
            </ul>
          </div>
          <div class="text-left">
            <h3 class="text-sm text-[var(--text)] font-regular mb-4">Legal</h3>
            <ul
              class="
                space-y-2
                text-xs text-[var(--text)] font-light
                pl-1
              "
            >
              <li>
                <a
                  :href="`${usersLink}/privacy-policy`"
                  target="_blank"
                  class="
                    opacity-50 hover:opacity-100
                    transition-all duration-300 ease-in-out
                  "
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
        </div>

        <div
          class="
            flex justify-between items-center
            border-t border-[var(--border)]
            pt-8
            pb-20
          "
        >
          <p class="text-xs text-[var(--text-secondary)] font-light">&copy;
            {{ currentYear }} digi systems All rights reserved.</p>
          <button
            @click="toggleTheme"
            class="rounded-full">
            <img
              :src="isLight
              ? '/icon/icon-light.svg'
              : '/icon/icon-dark.svg'"
              alt="theme toggle"
              class="w-5 h-5 opacity-70 hover:opacity-100 transition"
            />
          </button>
        </div>
      </div>
    </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  defineAsyncComponent,
  computed,
  onMounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));
const NewEventModal = defineAsyncComponent(() => import('@/views/app/events/new.vue'));
const EventDetailsModal = defineAsyncComponent(() => import('@/components/global/event-details-modal.vue'));
const ModalPlanner = defineAsyncComponent(() => import('@/components/global/modal-planner.vue'));

const { VUE_APP_DG_USERS_APP } = process.env;
const usersLink = VUE_APP_DG_USERS_APP || '';
const currentYear = new Date().getFullYear();

const isHome = computed(() => route.name === 'home');
const isAuth = computed(() => store.getters['auth/isAuth']);
const showSidebar = computed(() => isAuth.value && !isHome.value);

onMounted(() => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('sidebarOpen');
    if (stored !== null) {
      store.commit('setSidebar', stored === 'true');
    }
    console.log('events3->', store.state.events.events);

    // Listen for WebSocket reconnect events dispatched from visibilitychange
    window.addEventListener('reconnect-ws', ((e: Event) => {
      const payload = (e as CustomEvent).detail;
      if (payload) {
        store.dispatch('events/listWs', payload).catch(console.error);
      }
    }));
  }
});
</script>

<style scoped>
.blocker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.9); /* Change the alpha value for darkness */
  z-index: 20; /* Ensure it's above the sidebar */
}

@media (max-width: 639px) {
  .auth-app {
    height: 100vh !important;
    overflow: hidden !important;
    position: fixed !important;
    width: 100vw !important;
    display: flex !important;
    flex-direction: column !important;
  }
  .auth-app > div[data-scroll-container="app-content"] {
    flex: 1 !important;
    height: 100% !important;
    overflow-y: auto !important;
  }
}
</style>
